export default {
  amazon: 'cursor-pointer font-medium text-[#2973B6] hover:opacity-80 focus:outline-none transition',
  greenhouse: 'cursor-pointer font-medium text-[#24A580] hover:opacity-80 focus:outline-none transition',
  k9ActivityClub: 'cursor-pointer font-medium text-[#EC5A26] hover:opacity-80 focus:outline-none transition',
  k9CrazyDogClub: 'cursor-pointer font-medium text-[#8F1D58] hover:opacity-80 focus:outline-none transition',
  kagome: 'cursor-pointer font-medium text-[#2D3096] hover:opacity-80 focus:outline-none transition',
  ossur: 'cursor-pointer font-medium text-[#3274B8] hover:opacity-80 focus:outline-none transition',
  primary: 'cursor-pointer font-medium text-ocean-700 hover:text-ocean-500 focus:outline-none focus:underline transition',
  ocean: 'cursor-pointer font-medium text-ocean-700 hover:text-ocean-500 focus:outline-none focus:underline transition',
};
